import axios from "axios";
import type { ApiRequestOptions } from "../types";

const API_URL = process.env.REACT_APP_API_URL;

const client = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

class BaseApi {
  API = async (options: ApiRequestOptions): Promise<any> => {
    const headers: Record<string, any> = {
      ...(options.headers || {}),
    };
    const regPassword = sessionStorage.getItem("retreat-registration-password");
    if (regPassword) {
      headers["x-registration-password"] = regPassword;
    }

    return client({
      ...options,
      headers,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => console.log("Network Error", error));
  };

  async uploadFile(data: FormData | unknown): Promise<any> {
    return await this.API({
      url: "/upload",
      data,
      method: "post",
    });
  }
}

export default BaseApi;
